import { Platform } from 'react-native'

import { reportNativeError } from './nativeCrashReporting.helper'

interface NewRelicBrowserAgent {
  noticeError?: (error: Error, customAttributes?: Record<string, unknown>) => void
}

export function reportClientError(
  error: Error,
  context?: Record<string, unknown>,
): void {
  if (Platform.OS !== 'web') {
    reportNativeError(error, context)
    return
  }

  if (typeof window === 'undefined') {
    return
  }

  const nr = (window as Window & { newrelic?: NewRelicBrowserAgent }).newrelic
  nr?.noticeError?.(error, context)
}
